export const GENERIC_CERT_DIMENSIONS = {
  WIDTH: 1584,
  HEIGHT: 1224
};